import React from 'react';

const CorrectIcon: React.FC = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <foreignObject x="-16" y="-16" width="54" height="54">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: 'blur(8px)',
            clipPath: 'url(#bgblur_0_8108_48838_clip_path)',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <g data-figma-bg-blur-radius="16">
        <path
          d="M10.9999 1.83301C5.93992 1.83301 1.83325 5.93967 1.83325 10.9997C1.83325 16.0597 5.93992 20.1663 10.9999 20.1663C16.0599 20.1663 20.1666 16.0597 20.1666 10.9997C20.1666 5.93967 16.0599 1.83301 10.9999 1.83301ZM9.16658 15.583L4.58325 10.9997L5.87575 9.70717L9.16658 12.9888L16.1241 6.03134L17.4166 7.33301L9.16658 15.583Z"
          fill="#00D85A"
        />
      </g>
      <defs>
        <clipPath id="bgblur_0_8108_48838_clip_path" transform="translate(16 16)">
          <rect width="22" height="22" rx="11" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CorrectIcon;
